import '../styles/unauthorized.scss';

const UnAuthorized = () => (
    <div className="report-inspector_unauthorized">
        <div>
            <span className="appkiticon icon-alert-outline a-font-40 a-text-red" />
        </div>
        <div className="a-mt-10 a-h2">You are not authorized to view this page.</div>
    </div>
);

export default UnAuthorized;
